<template>
  <div class="job-header">
    <button
      id="schedule"
      @click="$emit('tab_selected', -1)"
      v-bind:class="{ selected: selected == -1 }"
      class="btn btn-plt"
    >
      Schedule
    </button>
    <button
      v-for="(item, index) in schedules"
      v-bind:key="item.id"
      :id="item.id"
      @click="$emit('tab_selected', index)"
      v-bind:class="{ selected: selected == index }"
      class="btn btn-plt"
    >
      Every {{ item.duration }} Week Schedule
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "JobScheduleSelectHeader",
  props: {
    selected: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState("schedule", ["schedules"]),
  },
};
</script>
